import episodeRouter from "@/routes/episodeRouter"
import { i18n } from "@/plugins/i18n"

export default [
  {
    path: "podcasts",
    component: () => import("@/views/Podcasts/Podcasts.vue"),
    children: [
      {
        path: "",
        name: "podcasts",
        component: () => import("@/views/Podcasts/PodcastList.vue"),
        meta: {
          pageTitle: i18n.t("route.page_title.account.podcasts.list"),
          rule: "owner",
        },
      },
      {
        path: "create",
        component: { render: (h) => h("router-view") },
        children: [
          {
            path: "",
            name: "podcast.create",
            component: () => import("@/views/Podcasts/PodcastAdd.vue"),
            props: true,
            meta: {
              pageTitle: i18n.t("route.page_title.account.podcasts.create"),
              parent: "podcasts",
              rule: "owner",
            },
          },
          {
            path: "classic",
            name: "podcast.create.classic",
            component: () => import("@/views/Podcasts/PodcastCreateClassic.vue"),
            props: true,
            meta: {
              pageTitle: i18n.t("route.page_title.account.podcasts.create"),
              parent: "podcasts",
              rule: "owner",
            },
          },
          {
            path: "ai",
            name: "podcast.create.ai",
            component: () => import("@/views/Podcasts/PodcastCreateAi.vue"),
            props: true,
            meta: {
              pageTitle: i18n.t("route.page_title.account.podcasts.create"),
              parent: "podcasts",
              rule: "owner",
            },
          },
        ],
      },
      {
        path: ":podcastKey",
        component: () => import("@/views/Podcasts/Podcast.vue"),
        name: "podcast",
        props: true,
        meta: {
          pageTitle: "Podcast info",
          parent: "podcasts",
          rule: "owner",
        },
        children: [
          {
            name: "podcast.distribute",
            path: "distribute",
            component: () => import("@/views/Podcasts/PodcastDistribute.vue"),
            meta: {
              pageTitle: i18n.t("podcasts.distribute_title"),
              parent: "podcasts",
              rule: "owner",
            },
          },
          {
            // the sections of the podcast settings; the first one keeps the name and the URL the page always had
            path: "settings",
            component: () => import("@/views/Podcasts/PodcastSettings.vue"),
            children: [
              {
                name: "podcast.settings",
                path: "",
                component: () => import("@/views/Podcasts/PodcastSettingsInfo.vue"),
                meta: {
                  pageTitle: i18n.t("podcasts.settings_title"),
                  parent: "podcasts",
                  rule: "owner",
                },
              },
              {
                name: "podcast.settings.access",
                path: "access",
                component: () => import("@/views/Podcasts/PodcastSettingsAccess.vue"),
                meta: {
                  pageTitle: i18n.t("podcasts.settings_access_title"),
                  parent: "podcasts",
                  rule: "owner",
                },
              },
            ],
          },
          {
            name: "podcast.ads_settings",
            path: "ad-settings",
            component: () => import("@/views/Podcasts/AdPlacement.vue"),
            meta: {
              pageTitle: i18n.t("podcasts.ads_settings_title"),
              parent: "podcasts",
              rule: "owner",
            },
          },
          ...episodeRouter,
        ],
      },
    ],
  },
]
